import gql from 'graphql-tag';

export const EMPLOYEE_FORM_UNIT_SETTINGS = gql`
  query employeeFormUnitSettings {
    currentUnit {
      id
      unitSetting {
        id
        unitPaycheckSetting {
          id
          defaultWorkRelation {
            subUnitId
            occupationId
            employmentType
            durationType
            shiftType
            hoursEveryWeekWithFullEmployment
            employmentPercentage
          }
        }
      }
    }
  }
`;
